import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 20h6","key":"svg-0"}],["path",{"d":"M12 20v-8","key":"svg-1"}],["path",{"d":"M5 12h14l-4 -8h-6z","key":"svg-2"}]]

const IconLamp = createReactComponent('outline', 'lamp', 'Lamp', __iconNode);

export default IconLamp;